import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Box, Button, FormField, ModalContext, SidebarNoticeBox, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useAgency from '@hooks/useAgency'
import useConversationContainer from '@hooks/useConversationContainer'

const ManageAgencyEnabledStatusModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { updateAgencyEnabled } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { agency } = modalPayload

  const {
    callbacks: { updateAgency },
    isActive,
    updating,
  } = useAgency(agency)

  const conversationContainerPayload = useConversationContainer({
    conversation: { subject_id: agency?.id, subject_type: 'Agency' },
  })

  const {
    callbacks: { createCommentWithConversation },
    commentForm,
  } = conversationContainerPayload

  const {
    entityState,
    entityState: { body },
    handlers,
  } = commentForm

  const saveButtonText = isActive ? 'Disable Agency' : 'Enable Agency'
  const saveEnabled = !!body

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title={isActive ? 'Disable' : 'Enable'} titleSecondLine="Agency" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          {isActive && (
            <SidebarNoticeBox>
              <SidebarNoticeBox.Title>This will disable the agency</SidebarNoticeBox.Title>
              <SidebarNoticeBox.Paragraph>
                Once an agency is disabled the client will no longer have access to their account.
                &nbsp;Please add a note to describe the reason for disabling.
              </SidebarNoticeBox.Paragraph>
            </SidebarNoticeBox>
          )}

          {!isActive && (
            <SidebarNoticeBox>
              <SidebarNoticeBox.Title>This will enable the agency</SidebarNoticeBox.Title>
              <SidebarNoticeBox.Paragraph>
                Please add a note to describe the reason for enabling.
              </SidebarNoticeBox.Paragraph>
            </SidebarNoticeBox>
          )}

          <FormField direction="column" label="Note or Description">
            <textarea
              name="body"
              style={{ height: 120 }}
              value={body}
              {...handlers}
            />
          </FormField>
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          onClick={() => (
            updateAgencyEnabled(entityState, { active: !isActive }, createCommentWithConversation, updateAgency)
          )}
          size="large"
        >
          {saveEnabled ? saveButtonText : 'Complete Note'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManageAgencyEnabledStatusModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManageAgencyEnabledStatusModal.defaultProps = {
  modalKey: 'ManageAgencyEnabledStatusModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManageAgencyEnabledStatusModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
